<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3 mt-2">
          <div class="vx-row">
            <router-link to="/inventory/stocktransfer">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("stockTransfer.label.header") }}</h3>
          </div>
        </ul>
      </div>
      <div class="w-full">
        <vx-card no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
              <vs-radio
                v-model="formStockTransferRadio"
                vs-value="individualLoadRadio"
                color="success"
                >{{ $t("stockUpload.label.add.Individual Load") }}</vs-radio
              >
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
              <vs-radio
                v-model="formStockTransferRadio"
                color="success"
                vs-value="bulkLoadRadio"
                >{{ $t("stockUpload.label.add.Bulk Load") }}</vs-radio
              >
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/6 xl:w-1/6">
              <vs-radio
                v-if="type !== 'ItemSale'"
                v-model="formStockTransferRadio"
                color="success"
                vs-value="cartoonTransferRadio"
                >{{ $t("inventory.label.CartoonTransfer") }}</vs-radio
              >
            </div>
          </div>
          <div
            class="vx-row mt-4"
            v-if="formStockTransferRadio == 'individualLoadRadio'"
          >
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{ $t("Type") + " * " }}</small>
                <v-select
                  label="item"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  class="mb-2"
                  v-model="type"
                  disabled
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('inventory.label.id')"
                v-model="id"
                disabled
                class="w-full mb-2 font-semibold"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('stockUpload.label.add.itemDescription')"
                v-model="itemDescription"
                disabled
                class="w-full mb-2 font-semibold"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('stockUpload.label.add.Serial No')"
                v-model="serialNo"
                class="w-full mb-2 font-semibold starlabel"
              />
            </div>
          </div>
          <div
            class="vx-row mt-4"
            v-else-if="formStockTransferRadio == 'cartoonTransferRadio'"
          >
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('inventory.label.Type')"
                v-model="type"
                class="w-full mb-2 font-semibold"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('inventory.label.MRN_Id')"
                v-model="id"
                class="w-full mb-2 font-semibold"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('stockUpload.label.add.Carton No')"
                v-model="cartoonNumber"
                class="w-full mb-2 font-semibold"
              />
            </div>
          </div>
          <div
            class="vx-row mt-4"
            v-else-if="formStockTransferRadio == 'bulkLoadRadio'"
          >
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="selectDownloadSec">
                <div class="dropdown-with-label">
                  <small class="date-label font-semibold"
                    >{{ $t("stockUpload.label.add.Select Name")
                    }}<span class="required"> *</span></small
                  >
                  <v-select
                    label="name"
                    v-model="selectName"
                    :options="['MRN', 'Move Itemsale', 'MrnCarton']"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.name
                    }}</template>
                  </v-select>
                </div>
                <div class="downloadFromHere text-center">
                  <a href="/csv/Hardware Items.csv" download
                    ><img src="@/assets/images/icons/download.svg" /> {{$t("inventory.label.Download_From_here")}}</a
                  >
                </div>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <label class="form__container">
                <img src="@/assets/images/icons/Upload.svg" />
                <div v-if="!uploadedFileName">
                  {{$t("inventory.label.Browse_file_to_Upload")}}
                </div>
                <div style="margin: -3rem 0; color: #44bb44">
                  {{ uploadedFileName }}
                </div>
                <input class="form__file" type="file" @change="uploadOnChange"
              /></label>
            </div>
            <div class="vx-col w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("stockUpload.label.add.Description")
                  }}<span class="required"> *</span></small
                >
                <vs-textarea
                  :placeholder="$t('inventory.label.Description')"
                  v-model="UploadDescription"
                />
              </div>
            </div>
          </div>
          <!-- <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <vs-input :label="$t('Grv Id')" class="w-full mb-2 font-semibold" />
          </div>
          <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
            <vs-input
              :label="$t('Serial No*')"
              class="w-full mb-2 font-semibold"
            />
          </div> -->
        </vx-card>

        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="saveCancelBtn mb-3">
              <vs-button type="border" class="mb-2" @click="cancel"
                >{{ $t("stockTransfer.label.Cancel") }}
              </vs-button>
              <vs-button class="mr-3 mb-2" @click="submitForm">{{
                $t("inventory.label.Submit")
              }}</vs-button>
            </div>
          </div>
        </div>
        <vx-card
          no-shadow
          card-border
          class="mb-base table-search-zero-margin"
          v-if="formStockTransferRadio == 'bulkLoadRadio'"
        >
          <vs-table :max-items="5" pagination :data="bulkUpload" search>
            <template slot="header">
              <!-- ADD NEW -->
            </template>
            <template slot="thead">
              <vs-th>{{ $t("stockUpload.label.add.Upload Process") }}</vs-th>
              <vs-th>{{ $t("stockUpload.label.add.Upload File Path") }}</vs-th>
              <vs-th>{{ $t("stockUpload.label.add.Process Date") }}</vs-th>
              <vs-th>{{
                $t("stockUpload.label.add.Process/Total Records")
              }}</vs-th>
              <vs-th>{{ $t("inventory.label.status") }}</vs-th>
              <vs-th class="tHeadCenter">{{
                $t("inventory.label.action")
              }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(uploads, index) in data">
                <vs-td :data="uploads.uploadProcess">{{
                  uploads.uploadProcess
                }}</vs-td>
                <vs-td :data="uploads.uploadFilePath">{{
                  uploads.uploadFilePath
                }}</vs-td>
                <vs-td :data="getDate(uploads.processDate)">{{
                  getDate(uploads.processDate)
                }}</vs-td>
                <vs-td
                  >{{ uploads.processRecords }}/{{
                    uploads.totalRecords
                  }}</vs-td
                >
                <vs-td :data="uploads.processStatus">{{
                  uploads.processStatus
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      :title="$t('inventory.label.Download_Log_File')"
                      icon="DownloadCloudIcon"
                      @click="downloadLog(uploads.id)"
                      svgClasses="w-5 h-5 stroke-current text-cloud"
                      class="icon_row"
                    />
                    <feather-icon
                      :title="$t('inventory.label.Download_Uploaded_File')"
                      icon="DownloadIcon"
                      class="text-warning icon_row"
                      @click="downloadFile(uploads.id, uploads.uploadFilePath)"
                      svgClasses="w-5 h-5 stroke-current"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import _ from "lodash";
import { BUCKET_BASE_URL } from "@/http/index";
import { mapState } from "vuex";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      UploadDescription: "",
      selectName: "",
      file: null,
      type: "",
      id: "",
      itemDescription: "",
      serialNo: "",
      formItemsaleMRNGRV: "Itemsale",
      formStockTransferRadio: "individualLoadRadio",
      bulkUpload: [],
      cartoonNumber: "",
      uploadedFileName: null,
    };
  },

  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    // bulkUpload() {
    //   return this.$store.getters["admin/getBulkUploads"];
    // },
  },

  methods: {
    async submitForm() {
      if (this.formStockTransferRadio == "bulkLoadRadio") {
        this.addBulkUploadFile();
      } else {
        let payload = {};
        if (this.type.toLowerCase() === "mrn") {
          if (this.formStockTransferRadio == "cartoonTransferRadio") {
            payload = {
              locale: "en",
              movedDate: new Date().toJSON().slice(0, 10),
              mrnId: this.id,
              cartoonNumber: this.cartoonNumber,
              type: "mrn",
            };
            try {
              await this.$store.dispatch(
                "inventory/movemrncartonAction",
                payload
              );
              this.$router.push("/inventory/stocktransfer");
            } catch (e) {
              this.errorMessage =
                e.message.errors[0].defaultUserMessage.replace(
                  "The parameter",
                  ""
                );
              this.warningPopup = true;
              this.errors = e.message.errors;
            }
          } else if (this.formStockTransferRadio == "individualLoadRadio") {
            payload = {
              locale: "en",
              movedDate: new Date().toJSON().slice(0, 10),
              mrnId: this.id,
              serialNumber: this.serialNo,
              type: "mrn",
            };
            try {
              await this.$store.dispatch("inventory/moveMrnAction", payload);
              this.$router.push("/inventory/stocktransfer");
            } catch (e) {
              this.errorMessage =
                e.message.errors[0].defaultUserMessage.replace(
                  "The parameter",
                  ""
                );
              this.warningPopup = true;
              this.errors = e.message.errors;
            }
          }
        } else if (this.type.toLowerCase() === "grv") {
          payload = {
            locale: "en",
            movedDate: new Date().toJSON().slice(0, 10),
            grvId: this.id,
            serialNumber: this.serialNo,
            type: "grv",
          };
          try {
            await this.$store.dispatch("inventory/moveGrvAction", payload);
            this.$router.push("/inventory/stocktransfer");
          } catch (e) {
            this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
              "The parameter",
              ""
            );
            this.warningPopup = true;
            this.errors = e.message.errors;
          }
        } else {
          payload = {
            locale: "en",
            movedDate: new Date().toJSON().slice(0, 10),
            itemId: this.id,
            serialNumber: this.serialNo,
            type: "sale",
          };
          try {
            await this.$store.dispatch("inventory/moveSaleAction", payload);
            this.$router.push("/inventory/stocktransfer");
          } catch (e) {
            this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
              "The parameter",
              ""
            );
            this.warningPopup = true;
            this.errors = e.message.errors;
          }
        }
      }
    },
    cancel() {
      this.$router.push(`/inventory/stocktransfer`);
    },
    downloadLog(id) {
      window.open(
        BUCKET_BASE_URL + `/datauploads/printlog/${id}?tenantIdentifier=default`
      );
    },

    downloadFile(id, path) {
      this.$store
        .dispatch("inventory/downloadFileAction", id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", path.replace(/^.*[\\\/]/, ""));
          document.body.appendChild(link);
          link.click();
        })
        .catch(console.error);
    },
    async addBulkUploadFile() {
      let formData = new FormData();
      formData.append("status", this.selectName);
      formData.append("description", this.UploadDescription);
      formData.append("file", this.file);
      try {
        await this.$store.dispatch("inventory/bulkUploadAction", formData);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "File Uploaded successfully!",
          type: "success",
        });
        this.getDataUploads();
      } catch (e) {
        this.$swal({
          title: "Failure",
          icon: "warning",
          text: "Something Went Wrong",
          type: "error",
        });
      }
    },

    uploadOnChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      this.uploadedFileName = this.file.name;
    },
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    async getDataUploads() {
      try {
        let res = await this.$store.dispatch("inventory/setBulkUploads");
        this.bulkUpload = res.pageItems || [];
        console.log("bulkUpload data:", this.bulkUpload);
      } catch (error) {
        console.log(
          "something went to wrong while retrieving bulk Uploads:",
          error
        );
      }
    },
  },
  mounted() {
    let pathData = this.$route.params.id;
    let id = pathData.replace(/[^0-9]+/g, "");
    let type = pathData.replace(/[^a-z]/gi, "");
    this.type = type;
    this.id = id;
    this.itemDescription = this.$route.params.item;
    this.getDataUploads();
  },
};
</script>
<style scoped>
.radioUpperCase .vs-radio--label {
  text-transform: uppercase;
}
.downloadFromHere img {
  margin: 0 auto;
  margin-bottom: 10px;
}
.downloadFromHere a {
  color: #000;
  text-transform: uppercase;
  font-weight: 600;
}
.selectDownloadSec {
  background: #f8f8f8;
  padding: 15px;
  border-radius: 12px;
}
.form__container {
  position: relative;
  width: 100%;
  height: 195px;
  border: 2px dashed #bbb5ff;
  display: block;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  color: silver;
  margin-bottom: 5px;
  background: #e9e7ff;
  border-radius: 12px;
  border-color: #bbb5ff;
  padding: 50px 0;
}
.form__file {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  opacity: 0;
}
.form__container img {
  margin: 0 auto;
  margin-bottom: 20px;
}
.marginB40 {
  margin-bottom: 40px;
}
</style>
